
import { KioskTypes } from "./kiosk-types";
export class Kiosk {

    constructor() {
        this.type = "";
        this.settings = new Array<KioskSetting>();
    }

    id: string;
    isActive: boolean;
    name: string;
    ssid: string;
    kioskId: string;
    tenantId: string;
    notes: string;
    created: Date;
    modified: Date;
    password: string;
    type: string;
    timeZone: string;
    timeZoneAbbreviation: string;
    syncTimestampLocal: string;
    syncUserName: string;
    machineLogin: boolean;
    wiFiPassword: string;
    
    settings: Array<KioskSetting>;

}

export class KioskTypeOption {
    constructor(type: string) {
        this.id = type;
        this.value = type;
    }

    id: string;
    value: string;
}

export class ProcessingService {
    constructor(name: string, type: string) {
        this.name = name;
        this.type = type;
    }

    name: string;
    type: string;
}

export class KioskSetting {

    constructor(name: string, type: string) {
        this.name = name;
        this.type = type;
    }

    id: string;
    isActive: string;
    name: string;
    kioskId: string;
    value: string;
    type: string;
    tenantId: string;
    notes: string;
    created: Date;
    modified: Date;

}
